import { Pipe, PipeTransform } from '@angular/core';
import {EmailAddress} from "../interface/email-address";

@Pipe({
  name: 'mainContact'
})
export class MainContactPipe implements PipeTransform {

  transform(value: any): any {
    return value.filter((el: EmailAddress) => el.main);
  }

}
